import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pending-verification-dialog',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatDialogModule],
  template: `
    <div class="pending-wrapper">
      <mat-icon class="pending-icon">hourglass_top</mat-icon>
      <h2 class="title">Pendiente por verificar</h2>
      <p class="subtitle">
        Tu pago está en proceso y a la espera de verificación.
      </p>
    </div>
  `,
  styles: [
    `
      .pending-wrapper {
        text-align: center;
        padding: 24px 20px 12px;
        max-width: 340px;
      }
      .pending-icon {
        font-size: 72px;
        width: 72px;
        height: 72px;
        color: #5bb0ff; /* lighter blue */
        margin-bottom: 12px;
      }
      .title {
        margin: 0 0 8px;
        font-size: 20px;
        font-weight: 600;
        color: #3fa0ff; /* lighter blue */
      }
      .subtitle {
        margin: 0 0 20px;
        font-size: 14px;
        color: #444;
      }
      button {
        min-width: 140px;
      }
    `,
  ],
})
export class PendingVerificationDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<PendingVerificationDialogComponent>
  ) {}
  close() {
    this.dialogRef.close();
  }
}
